module.exports = __webpack_public_path__ + "img/alter-ego-hero_en.f23b639.png";